import { Routes, Route, useNavigate } from "react-router-dom";
// Material-UI imports
import { Paper } from "@mui/material";

// MSAL imports
import {MsalProvider, useMsal} from "@azure/msal-react";
import { IPublicClientApplication } from "@azure/msal-browser";
import { CustomNavigationClient } from "./utils/NavigationClient";

// Auth0 imports
import {auth0Config, loginRequest} from "./authConfig";

// Sample app imports
import { PageLayout } from "./ui-components/PageLayout";
import { Home } from "./pages/Home";
import { Profile } from "./pages/Profile";
import {AuthenticationProvider} from "@lectra/react-authentication";
import {ProfileAuth0} from "./pages/ProfileAuth0";
import {ExtendedAuth0ProviderOptions} from "@lectra/react-authentication/build/types";
import {useEffect} from "react";
import ChannelsList from "./pages/ChannelsList";
import SendMessage from "./pages/SendMessage";

type AppProps = {
    pca: IPublicClientApplication;
};

function App({ pca }: AppProps) {
    // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
    const navigate = useNavigate();
    const navigationClient = new CustomNavigationClient(navigate);
    pca.setNavigationClient(navigationClient);

    return (
        <AuthenticationProvider
            auth0={ auth0Config as ExtendedAuth0ProviderOptions }
            // permission={ADMIN_PERMISSION}
            // redirectTo403IfForbidden
            // SSOHeartBeat
            environment={ "DEV" }
        >
            <MsalProvider instance={pca}>
                <PageLayout>
                    <Paper variant="outlined" sx={{m: 3, p: 2, borderRadius: 2}}>
                        <Pages />
                    </Paper>
                </PageLayout>
            </MsalProvider>
        </AuthenticationProvider>
    );
}

function Pages() {
    const { instance } = useMsal();
    const accounts = instance.getAllAccounts();

    useEffect(() => {
        const handleAuthentication = async () => {
            try {
                // Si aucun compte n'est présent
                if (accounts.length === 0) {
                    // Essayer d'abord une authentification silencieuse
                    try {
                        await instance.ssoSilent({
                            ...loginRequest,
                            prompt: "none"
                        });
                        console.log("Authentification silencieuse réussie");
                    } catch (silentError) {
                        console.log("Authentification silencieuse échouée, utilisation du popup:", silentError);
                        // Si l'authentification silencieuse échoue, utiliser le popup
                        await instance.loginPopup(loginRequest);
                    }
                }
            } catch (error) {
                console.error("Erreur d'authentification:", error);
            }
        };

        void handleAuthentication();
    }, [instance, accounts.length]);

    return (
        <Routes>
            <Route path="/profile" element={<Profile />} />
            <Route path="/profileAuth0" element={<ProfileAuth0 />} />
            <Route path="/channels" element={<ChannelsList />} />
            <Route path="/messages" element={<SendMessage />} />
            <Route path="/" element={<Home step={"init"}/>} />
            <Route path="/entra/redirect" element={<Home step={"from ENTRA"}/>} />
            <Route path="/auth0/redirect" element={<Home step={"from AUTH0"}/>} />
        </Routes>
    );
}

export default App;